<div>
  <app-ov-video [streamManager]="streamManager"></app-ov-video>
<!--  <div><p>{{getNicknameTag()}}</p></div>-->
</div>
